import { compose, defaultProps, withHooks } from "enhancers"
import { Box } from "components"
import { DatePicker as FormikMuiDatePicker, DatePickerProps } from "formik-material-ui-pickers"
import format from "date-fns/format"
import get from "lodash/get"

import { ReactComponent as DatePickerIcon } from "assets/icon/datepicker_icon.svg"

interface DateProps extends DatePickerProps {
  width: string | number
}

const DatePicker = (props: DateProps) => (
  <Box width={props.width} position="relative">
    <FormikMuiDatePicker {...props} />
    <Box position="absolute" top={12} right={12}>
      <DatePickerIcon />
    </Box>
  </Box>
)

const enhancer = compose(
  defaultProps({ format: "dd/MM/yyyy", placeholder: "วันที่" }),
  withHooks((props: any, hooks: any) => {
    const { useMemo } = hooks

    const error = useMemo(() => {
      const touched = get(props.form.touched, props.field.name) || props.form.submitCount > 0
      const error = get(props.form.errors, props.field.name)
      return touched && !!error
    }, [props.form, props.field])

    return {
      ...props,
      error,
      labelFunc: (date: Date, invalidLabel: string) => (props.field.value ? format(date, props.format) : ""),
    }
  }),
)

export default enhancer(DatePicker)
